import { Component } from '@angular/core';

@Component({
  selector: 'app-quad-grid',
  templateUrl: './quad-grid.component.html',
  styleUrls: ['./quad-grid.component.css']
})
export class QuadGridComponent {

}
